import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// Shared UI Library Components
import { SpinElement } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './business-profile-layout.scss';

// Components
import { AsideMenu } from './components/aside-menu/aside-menu';

// Store Entities
import {
  fetchCompanyAllAvailableCountries,
  fetchCompanyAllAvailableLanguages
} from '../../store/company/company.thunks';
import { getCoreState } from '../../store/core/core.selectors';
import { getCompanyState } from '../../store/company/company.selectors';

type TBusinessProfileLayoutProps = {};

export const BusinessProfileLayout = ({}: TBusinessProfileLayoutProps) => {

  const { path } = useSelector(getCoreState);
  const { company, loading } = useSelector(getCompanyState);

  const dispatch = useDispatch<any>();

  const loadAllLanguages = (): void => {
    dispatch(fetchCompanyAllAvailableLanguages());
  };

  const loadAllCountries = (): void => {
    dispatch(fetchCompanyAllAvailableCountries());
  };

  useEffect(() => {
    loadAllLanguages();
    loadAllCountries();
  }, []);

  return (
    <div className="business-profile-layout">
      {
        loading &&
        <div className={ `business-profile-layout--loader business-profile-layout--loader-${ loading ? 'show' : 'hide' }` }>
          <SpinElement fullHeight={ true }/>
        </div>
      }

      <div className="business-profile-layout--content">
        <div className="content-aside">
          { company && <AsideMenu pathState={ path }/> }
        </div>
        <div className="content-body">
          <Outlet/>
        </div>
      </div>
    </div>
  );
}
